import { configureStore } from "@reduxjs/toolkit";
import carrommReducer from "./slices/carrommSlice";

export const store = configureStore({
  reducer: {
    carromm: carrommReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});
